/* Copyright (c) 2017 Backpack Health LLC */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import ContentLoader from '../ContentLoader';

import './SystemModal.styles.scss';
import './BackpackModal.scss';

import { selectors as systemModalSelectors, actions as systemModalActions } from '../../redux/ducks/systemModal';

const OVERFLOW_HIDDEN_CLASS = 'overflow-hidden';

function mapStateToProps(state) {
  const isSystemModalVisible = systemModalSelectors.isVisible(state);
  const blurSize = systemModalSelectors.getBlurSize(state);
  return {
    content: systemModalSelectors.getAllContent(state),
    isWithSliding: systemModalSelectors.isWithSliding(state),
    isLoaded: systemModalSelectors.isLoaded(state),
    onDismiss: systemModalSelectors.getOnDismiss(state),
    isBackgroundClickDisabled: systemModalSelectors.isBackgroundClickDisabled(state),
    blurClassName: isSystemModalVisible && blurSize ? `_${blurSize}` : '',
    isAutoDismissDisabled: systemModalSelectors.getIsAutoDismissDisabled(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dismissModal: () => {
      dispatch(systemModalActions.dismiss());
    },
  };
}


class SystemModal extends Component {
  state = {
    isHidden: true,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const bodyElem = document.querySelector('body');

    if (nextProps.content.length > 0) {
      bodyElem.classList.add(OVERFLOW_HIDDEN_CLASS);
    } else {
      bodyElem.classList.remove(OVERFLOW_HIDDEN_CLASS);
    }

    if (!nextProps.isLoaded) {
      this.setState({ isHidden: true });
      return;
    }

    if (nextProps.isWithSliding) {
      // if modal window should appear with sliding then first of it should be hidden
      this.setState({ isHidden: true }, () => {
        this.setState({ isHidden: false });
      });
    } else {
      this.setState({ isHidden: false });
    }
  }

  render() {
    if (this.props.content.length === 0) {
      return null;
    }

    const wrapperClassName = classnames('cmp-systemmodal-wrapper util-application-width', { 'is-hidden': this.state.isHidden });

    const visibleIndex = this.props.content.length - 1;

    return (
      <ContentLoader
        isContentLoaded={!this.state.isHidden}
        coverWholeScreen
        color="white"
      >
        <div className="cmp-systemmodal">
          <div
            className={classnames('cmp-systemmodal-background', this.props.blurClassName)}
            onClick={() => {
              if (!this.props.isBackgroundClickDisabled) {
                if (!this.props.isAutoDismissDisabled) {
                  this.props.dismissModal();
                }
                if (this.props.onDismiss) { this.props.onDismiss(); }
              }
            }}
          />
          <div className={wrapperClassName}>
            {
              this.props.content.map((c, i) => (
                <div key={i} className={classnames('cmp-systemmodal-content', (visibleIndex === i ? '_active' : classnames('_inactive', this.props.blurClassName)))}>
                  {c}
                </div>
              ))
            }
          </div>
        </div>
      </ContentLoader>
    );
  }
}
SystemModal.propTypes = {
  content: PropTypes.array,
  isWithSliding: PropTypes.bool,
  isLoaded: PropTypes.bool,
  onDismiss: PropTypes.func,
  dismissModal: PropTypes.func,
  isBackgroundClickDisabled: PropTypes.bool,
  onlyPrevious: PropTypes.bool,
  blurClassName: PropTypes.string,
  isAutoDismissDisabled: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(SystemModal);
